import Base from './Base';

export type ContestParticipateData = {
    email?: string;
    phone?: string;
    source?: string;
    [key: string]: unknown;
};

export type ContestParticipateResponse =
    | User
    | {
          user: User;
          newSubscriptions?: string[];
      };

class Contests extends Base {
    participate(id: string, data: ContestParticipateData, opts = null) {
        return this.postJSONWithSession<ContestParticipateResponse>(`/contests/${id}`, data, opts);
    }
}

export default Contests;
